import erickPhoto from "./images/erick.jpg";
import rivierPhoto from "./images/rivier.jpg";
import estebanPhoto from "./images/esteban.jpg";
import gil from "./images/gil.png";
import starling from "./images/starling.jpg";

export const membersList = [
  {
    name: "Erick Sosa Garcia",
    desc:
      "Hello I'm Erick I study Javascript, Typescript, Python, Golang, NodeJS, Deno and focused in open source.",
    email: "ericksosagarcias@gmail.com",
    photo: erickPhoto,
    work: "Full-Stack, Project Manager",
    social: {
      github: "https://github.com/buttercubz",
      linkedin: "https://www.linkedin.com/in/erick-sosa-garcia-301b45185/",
      twitter: "https://twitter.com/buttercubz",
    },
  },
  {
    name: "Rivier Grullon",
    desc:
      "I'm Rivier, I'm an enthusiastic developer, I study Javascript, Typescript, Python, NodeJs but actually I'm focused on Deno 🦕",
    email: "rgrullon@ipisdosaj.edu.do",
    photo: rivierPhoto,
    work: "Full-Stack, QA",
    social: {
      github: "https://github.com/RivierGrullon",
      twitter: "https://twitter.com/RamirezRivier",
      instagram: "https://www.instagram.com/ramirez.001",
    },
  },
  {
    name: "Jose Esteban Garcia",
    desc:
      "Hi! I'm Jose Esteban, web developer apprentice, always trying to learn something new. // Lover of cartoons and pizza 🍕",
    email: "josegg1897@gmail.com",
    photo: estebanPhoto,
    work: "Frontend, Designer",
    social: {
      github: "https://github.com/jose1897",
      linkedin:
        "https://www.linkedin.com/in/jose-esteban-garcia-grullon-443624198/",
      twitter: "https://twitter.com/egg_jose",
      instagram: "https://www.instagram.com/egg_jose/",
    },
  },
  {
    name: "Gil Rudolf Härdi",
    desc: "I'm learning nice stuff like Typescript, Golang and Python.",
    email: "ghaerdi@outlook.com",
    photo: gil,
    work: "Full-Stack, Designer",
    social: {
      github: "https://github.com/ghaerdi",
      linkedin: "https://www.linkedin.com/in/ghaerdi/",
      twitter: "https://twitter.com/ghaerdi",
      instagram: "https://www.instagram.com/ghaerdi/",
    },
  },
  {
    name: "Starling Lora",
    desc:
      "I'm Starling, I study JavaScript, Python, React Native, always trying to learn something new.",
    email: "starlinglora@gmail.com",
    photo: starling,
    work: "Full-Stack",
    social: {
      github: "https://github.com/slorard",
      linkedin:
        "https://www.linkedin.com/in/starling-lora-s%C3%A1nchez-a9b990209/",
      twitter: "https://twitter.com/starlingl_",
      instagram: "https://www.instagram.com/starlingl_",
    },
  },
];
